import React, { useState } from 'react'
import axios from 'axios'
import { getFullUrl } from '../../../../infrastructure/utils'
import { FETCH_STATUS } from '../../../../infrastructure/fetch/constants'

const ExportTicketsSold = ({ event, eventId, tags }) => {
    const [exportStatus, setExportStatus] = useState(FETCH_STATUS.NOT_STARTED)

    const onExport = () => {
        const url = getFullUrl(`/api/tickets-issued/export/${eventId}`)
        Promise.resolve()
            .then(setExportStatus(FETCH_STATUS.REQUESTED))
            .then(() =>
                axios({
                    url,
                    method: 'GET',
                    responseType: 'blob',
                }),
            )
            .then(response => {
                setExportStatus(FETCH_STATUS.SUCCEEDED)
                const url = window.URL.createObjectURL(
                    new Blob([response.data]),
                )
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', `${event.name}-tickets-issued.csv`)
                document.body.appendChild(link)
                link.click()
            })
            .catch(e => {
                if (axios.isCancel(e)) return
                setExportStatus(FETCH_STATUS.FAILED)
            })
    }
    return (
        <button onClick={onExport} className="btn btn-default btn-small">
            {
                {
                    [FETCH_STATUS.NOT_STARTED]: 'Export',
                    [FETCH_STATUS.REQUESTED]: 'Exporting ...',
                    [FETCH_STATUS.SUCCEEDED]: 'Export',
                    [FETCH_STATUS.FAILED]: 'Failed to Export',
                }[exportStatus]
            }
        </button>
    )
}
export default ExportTicketsSold
